import { addSign } from '../constants';


function getModString(modNumber) {
    let result = Math.floor((modNumber-10)/2);
    return addSign(result)
}

const SkillGridInput = ({value, cKey, disabled = false, handleChange, style}) => {

    const validate = (e, cKey, send = false) => {
        const numberSignRegex = /^[\d+-]*$/;
        
        // if input is numbers - or +
        if(numberSignRegex.test(e.target.value)) {
            // default to 10 if the input is empty before sending
            if(send && e.target.value.length === 0) {
                // If input is empty on send/onBlur, set to 10 or 0 if a save
                let isSave = cKey.substring(cKey.length-4, cKey.length) === 'save'
                e.target.value = isSave ? 0 : 10 
            }
            handleChange(e, cKey, undefined, undefined, send)
        }
    }

    return (
        <input className='statBlockSkillsInput' 
            disabled={disabled || handleChange === undefined}
            style={style} 
            value={value} 
            onFocus={(e) => e.target.select()} 
            type='text' 
            onChange={e => validate(e, cKey)} 
            onBlur={e => validate(e, cKey, true)} 
            onClick={(event) => event.stopPropagation()} 
        />
    )
}
const changeName = window.location.search.includes('becca')

function getName(skillName) {
    if(!changeName) {
        return skillName
    } else {
        let skillKeys = {
            'STR': 'P.Att.',
            'DEX': 'P.Def.',
            'CON': 'M.Att.',
            'INT': 'M.Def.',
        }

        return skillKeys[skillName]

    }
}

const SkillGridItem = ({skillName, skillTotal, skillSave, edit, handleChange}) => {
    let editStyle = edit ? {borderBottom: '3px dotted grey'} : {}
    let skill = getName(skillName)
    const bigLetter = skill.charAt(0); // Gets the first letter
    const smallLetters = skill.slice(1); // Gets the rest of the string

    let skillKeys = {
        'STR':['strength', 'strength_save'],
        'DEX':['dexterity', 'dexterity_save'],
        'CON':['constitution', 'constitution_save'],
        'INT':['intelligence', 'intelligence_save'],
        'WIS':['wisdom', 'wisdom_save'],
        'CHA':['charisma', 'charisma_save']
    }

    return (
        <>
            <div className="skillGridItem" style={{color: '#822000'}}>
                <strong>{bigLetter}<span>{smallLetters}</span></strong>
            </div>
            <div className="skillGridItem">
                <SkillGridInput value={skillTotal} cKey={skillKeys[skillName][0]} handleChange={handleChange} style={editStyle}/>
            </div>
            <div className="skillGridItem">
                <SkillGridInput value={getModString(skillTotal)} disabled={true}/>
            </div>
            {!changeName && 
                <div className="skillGridItem">
                    <SkillGridInput value={addSign(skillSave)} cKey={skillKeys[skillName][1]} handleChange={handleChange} style={editStyle}/>
                </div>
            }
            
            
        </> 
  );
}

export default SkillGridItem;